import preApprovalReducer from './preapproval.slice';

export * from './preapproval.slice';
export * from './preapproval.thunk';

export default preApprovalReducer;
